<div class="fulfillmentLanding cpp-wrapper">
  <div class="cppLandingPage">
    <div class="row">
      <div class="col-md-12 col-lg-12 margin-l0 cppTopSec">
        <h3>
          Crop Protection Error Order Maintenance
        </h3>
      </div>
    </div>

    <div class="form-sec">
      <div class="row margin-t10 margin-b10">
        <div class="col-md-9 col-lg-10 smallPadRgt0">
          <div class="row search-box-outer">
            <div class="col-md-4 col-lg-3 padding-r0 category-drop-outer borderRight">

              <div class="category-dropdown material-select">
                <ng-select [items]="searchTypeList"
                           name="ddlProductSearch"
                           [(ngModel)]="selectedValue"
                           [virtualScroll]="true"
                           [closeOnSelect]="true"
                           [selectOnTab]="true"
                           [clearable]="false"
                           bindValue="value"
                           labelForId="name"
                           [searchable]="false"
                           (change)="keepFilter(null, ' ')">
                </ng-select>
              </div>
            </div>
            <div class="col-md-8 col-lg-9 padding-l4 padding-r0 ">
              <div class="row material-select reports-search-filter">

                <div #productSearch *ngIf="selectedValue === 'Product Name'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter(null, ' ')" [(ngModel)]="productFilters.ProductName"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <ng-select #itemNo name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number'"
                           [items]="itemList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.ItemNo"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter(itemNo,'ItemNo')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>

                <ng-select #itemId name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Id'"
                           [items]="itemList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.ItemId"
                           [virtualScroll]="true"
                           bindLabel="id"
                           bindValue="id"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter(itemId,'ItemId')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.id}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>

                <ng-select #AccountNo *ngIf="selectedValue === 'Account' && isEvolveAccountRestriction == true"
                           [items]="ddlAccounts"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.AccountNo"
                           [virtualScroll]="true"
                           bindLabel="accountNameCityState"
                           bindValue="accountNumber"
                           [closeOnSelect]="true"
                           [searchFn]="accountSearchFn"
                           (change)="keepFilter(null, ' ')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row" *ngIf="item.accountNumber!=-1">
                        <div class="col-md-8">
                          <h4 class="name greenColor" [ngOptionHighlight]="search">
                            {{item.accountName}}
                          </h4>
                          <p class="address" [ngOptionHighlight]="search">
                            {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                          </p>
                          <p class="phoneNo" [ngOptionHighlight]="search">
                            {{item.primaryPhoneNumber}}
                          </p>
                          <p class="grower-nos">
                            <span class="grower-gln" [ngOptionHighlight]="search">
                              Account #: {{item.accountNumber}}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="row" *ngIf="item.accountNumber==-1">
                        <div class="col-md-8">
                          <h4 class="name" [ngOptionHighlight]="search">
                            {{item.accountName}}
                          </h4>
                          <p class="grower-nos">
                            <span class="grower-gln" [ngOptionHighlight]="search">
                              Account #: {{item.accountNumber}}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
                <div #productSearch *ngIf="selectedValue === 'Account No' && isEvolveAccountRestriction == false" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.TxtAccountNo"
                               placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                      </div>
                    </div>
                  </div>
                </div>
                <div #productSearch *ngIf="selectedValue === 'Account Name' && isEvolveAccountRestriction == false " class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.AccountName"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 maturitySelect padding-l0" *ngIf="selectedValue === 'Order Date'">
                  <div class="text-center deliveryDatePicker">
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromOrderDateFilter"
                             readonly [(ngModel)]="productFilters.FromOrderDate" (dateChange)="keepFilter(null, ' ');validateOrderDateFilter('fromOrderDate', $event);">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Order Date'">
                  <div class="text-center deliveryDatePicker">
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toOrderDateFilter"
                             readonly [(ngModel)]="productFilters.ToOrderDate" (dateChange)="keepFilter(null, ' ');validateOrderDateFilter('toOrderDate', $event);">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-6 maturitySelect padding-l0" *ngIf="selectedValue === 'Requested Arrival Date'">
                  <div class="text-center deliveryDatePicker">
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromRequestedDeliveryDateFilter"
                             readonly [(ngModel)]="productFilters.FromRequestedDeliveryDate" (dateChange)="keepFilter(null, ' ');validateRequestedDeliveryDateFilter('fromRequestedDeliveryDate', $event);">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Requested Arrival Date'">
                  <div class="text-center deliveryDatePicker">
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toRequestedDeliveryDateFilter"
                             readonly [(ngModel)]="productFilters.ToRequestedDeliveryDate" (dateChange)="keepFilter(null, ' ');validateRequestedDeliveryDateFilter('toRequestedDeliveryDate', $event);">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

                <div *ngIf="selectedValue == 'Sales Order Number'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.WinfieldReferenceNumber"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedValue == 'Order ID'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.WebOrderNumber"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedValue == 'Customer PO#'" class="wide100">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter(null, ' ');getCppOrders();" [(ngModel)]="productFilters.CustomerPONumber"
                               placeholder="Search..." type="text">
                      </div>
                    </div>
                  </div>
                </div>

                <ng-select #processingStatus name="ddlItemNoSearch" *ngIf="selectedValue === 'Processing Status'"
                           [items]="processingStatusList"
                           placeholder="Search..."
                           class="custom-select-grower"
                           [multiple]="true"
                           [hideSelected]="true"
                           [(ngModel)]="productFilters.ProcessingStatus"
                           [virtualScroll]="true"
                           bindLabel="value"
                           bindValue="value"
                           [closeOnSelect]="true"
                           [searchFn]="filterSearchFn"
                           (change)="keepFilter(processingStatus,'ProcessingStatus')">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div class="dropdown-template">
                      <div class="row">
                        <div class="col-md-8">
                          <p class="name">
                            {{item.value}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                    <div class="ng-option disabled">
                      No data found for "{{searchTerm}}"
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-lg-2 search-btn-outer text-right padding-r5">
          <div class="search-btn margin-r10 margin-t10">
            <button mat-raised-button class="btns" (click)="keepFilter(null, ' ');getCppOrders();" color="primary">Search</button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-10 padding-r0">
          <div class="chips-sec">
            <div class="row selected-chip">
              <div class="col-sm-9 col-md-10 padding-l0">
                <div>
                  <mat-chip-set>
                    <mat-chip selected *ngFor="let filterValue of filterValueList">
                      {{filterValue}}
                      <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                        <i class="fas fa-times text-right"></i>
                      </a>
                    </mat-chip>
                  </mat-chip-set>
                </div>
              </div>
              <div class="col-sm-3 col-md-2 text-right padding-r20" *ngIf="filterValueList.length > 0">
                <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row padding-t10">
      <div class="col-md-12">

        <ng-template mat-tab-label>
          <i class="icon-ico-grower_icon" aria-hidden="true"></i>
          <div class="tab-head">
            <h4>
              Errored Orders
            </h4>
          </div>
        </ng-template>
        <div class="fulfill-top-sec">
          <div class="row listing-action-items">
            <div class="col-xl-4 col-lg-4 col-md-4 smallPadRgt0">
              <div class="selectAllcheckSec">
                <mat-checkbox (change)="$event ? masterToggleErrored() : null"
                              [checked]="erroredSelection.hasValue() && isAllErroredSelected()"
                              [disabled]="readOnlyAccess"
                              [indeterminate]="erroredSelection.hasValue() && !isAllErroredSelected()" class="custom-checkbox select-all-check">
                </mat-checkbox>
                <i class="fas fa-sort-down light-gray-arrow" aria-hidden="true"></i>
              </div>
              <div class="action-links display-ib" *ngIf="showTabs && !readOnlyAccess">
                <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">
                  <div class="tab-bar ">
                    <div>
                      <span (click)="showTab('delivery')" [ngClass]="{'active': tabNode==='delivery'}" class="seperator calendarDate" matTooltip="Set Delivery Date" [matTooltipPosition]="'above'">
                        <i class="icon-ico-delivery"></i>
                      </span>
                      <span (click)="resubmitOrders()" [ngClass]="{'active': tabNode==='resubmit'}" class="seperator resubmit" matTooltip="Resubmit Orders" [matTooltipPosition]="'above'">
                        <i class="fas fa-external-link-alt"></i>
                      </span>
                    </div>
                  </div>

                  <div class="tab-content">
                    <div *ngIf="tabNode==='delivery'" class="deliveryDate">

                      <div class="tab-content-detail">
                        <ngb-datepicker [(ngModel)]="datemodel" [dayTemplate]="customDay" [markDisabled]="isDisabled" ngbDatepicker #d="ngbDatepicker"></ngb-datepicker>
                        <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                          <span class="custom-day" [class.weekend]="isWeekend(date)" [class.focused]="focused"
                                [class.bg-primary]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                            {{date.day}}
                          </span>
                        </ng-template>
                        <div class="btn-Sec text-center">
                          <button mat-raised-button class="btns normal-large-btn fullWidthBtn" color="primary" (click)="SetAllFields('deliverydate',datemodel)">Save</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-8 col-lg-8 col-md-8 text-right smallPadLeft0 padding-r10">
              <div class="display-ib wAuto">
                <mat-paginator #errorCPPOrdersPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
              </div>
            </div>
          </div>
        </div>
        <div class="tableContainer growertableContainer">
          <table mat-table #errorCPPOrdersTable [dataSource]="errorCPPOrdersDataSource" matSort #errorCPPOrdersSort matSortDirection="desc" class="matTables">

            <ng-container matColumnDef="releaseId">
              <th mat-header-cell *matHeaderCellDef class="chkbox">&nbsp;</th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox #SingleCheck (click)="$event.stopPropagation()"
                              (change)="$event ? erroredOrderCheckEvent(row, SingleCheck._checked) : null"
                              [checked]="erroredSelection.isSelected(row)"
                              [disabled]="readOnlyAccess"
                              class="custom-checkbox select-all-check">
                </mat-checkbox>
              </td>
              <td mat-footer-cell *matFooterCellDef> </td>
            </ng-container>

            <ng-container matColumnDef="webOrderNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="shipToLocation">Order ID</th>
              <td mat-cell *matCellDef="let element" class="text-left">
                <div class="padding-l10" (click)="navigateOrderDetail(element)">
                  <a> {{element.webOrderNumber}}-{{element.splitId}}</a>
                </div>
              </td>
              <td mat-footer-cell *matFooterCellDef> </td>
            </ng-container>

            <ng-container matColumnDef="purchaseOrderNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="webOrderNumber text-center">Customer PO#</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <div>
                  {{element.purchaseOrderNumber}}
                </div>
              </td>
              <td mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="orderCreateDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="orderCreateDate  text-center">Order Date</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.orderCreateDate | date:'MM/dd/yyyy'}} </td>
              <td mat-footer-cell *matFooterCellDef>  </td>
            </ng-container>

            <ng-container matColumnDef="requestDeliveryDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="rDeliveryDate text-center">Requested Arrival Date</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.requestDeliveryDate | date:'MM/dd/yyyy'}} </td>
              <td mat-footer-cell *matFooterCellDef>  </td>
            </ng-container>

            <ng-container matColumnDef="accountNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="accountNumber  text-center">Account #</th>
              <td mat-cell *matCellDef="let element" class="text-center"> {{element.accountNumber}} </td>
              <td mat-footer-cell *matFooterCellDef>  </td>
            </ng-container>
            <ng-container matColumnDef="accountName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="locationDetails text-center"> Account Name </th>
              <td mat-cell *matCellDef="let element">
                <div class="order-info defaultCursor">
                  <p class="grower-name">
                    {{element.accountName}}
                  </p>
                  <p>{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                </div>
              </td>
              <td mat-footer-cell *matFooterCellDef>  Error Orders: {{errorCPPOrdersList.length}} </td>
            </ng-container>

            <ng-container matColumnDef="successfullyProcessed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="instructions text-center">Processing Status</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <div *ngIf="element.successfullyProcessed=='E'">MasterData</div>
                <div *ngIf="element.successfullyProcessed=='F'">Integration Error</div>
                <div *ngIf="element.successfullyProcessed=='B'">Mulesoft/Azure</div>
              </td>
              <td mat-footer-cell *matFooterCellDef>  </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="errorCPPOrdersColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let row; columns: errorCPPOrdersColumns;"></tr>
            <!--<tr mat-footer-row *matFooterRowDef="errorCPPOrdersFooterColumns; sticky: true"></tr>-->
          </table>
          <div *ngIf="errorCPPOrdersList == undefined || errorCPPOrdersList.length == 0" class="noDataMsg">
            <p>No Record Found.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
